<template>
    <div class="newsandinformation">
        <div class="g-s-a-w">
            <img class="news_image" v-lazy="img[0]" style="width: 100%;position: relative;" />
        </div>
        <div class="introduction container_full po_r m_a">
            <!-- <div class="about_us">
                <div>
                    <p>About Us</p>
                </div>
                <ul class="active">
                    <div class="info">
                        <div class="info1">
                            <span class="info_active" @click="tiaoyemain('ContactChinaPostalAirlines')"
                                style="color: #FFFFFF;">About China Postal Airlines</span>
                        </div>
                    </div>
                </ul>
            </div> -->
            <div class="com_profile com_profile_active">
                <div class="detail">
                    <div v-show="list" style="padding-top: 40px;">
                        <div class="profile_middle" v-for="(item, index) in gonggao" :key="index">
                            <ul class="news_ul" @click="toAnnounceAnd(item.id)">
                                <li class="news_list">
                                    <ul class="con_left_css">
                                        <li class="news_tag">
                                            <img v-lazy="img[1]" class="img_css_two" />
                                            <span class="span_css3">{{ item.announcementName }}</span>
                                        </li>
                                        <li class="news_content">
                                            <span class="news_content_span">{{ item.announcementDetial }}</span>
                                        </li>
                                    </ul>
                                    <ul class="short_line">
                                        <li>
                                            <span class="short_line_span">{{ $moment(item.createDate).format("YYYY-MM-DD") }}</span>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                        <div class="page">
                            <div class="block">
                                <el-pagination @current-change="handleCurrentChanges"
                                    :current-page.sync="currentPage3" :page-size="PageSizes"
                                    layout="prev, pager, next, jumper" :total="gonggao_title">
                                </el-pagination>
                            </div>
                        </div>
                    </div>
                    <div class="fanhui" v-show="!list">
                        <span class="fanh" style="cursor: pointer;position: relative;top: 30px;"
                            @click="tiaoyemain('ContactChinaPostalAirlines')">&nbsp;{{ '<<' }}&nbsp;Back
                        </span>
                        <Details :detailsId="{ detailsId, status }" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Details from "./details.vue"
export default {
    inject: ["reload"],
    name: "ContactChinaPostalAirlines",
    data() {
        return {
            img: [
                require('@/assets/img/Abouts/quert.jpg'),
                require('@/assets/img/Abouts/gang.png'),
            ],
            currentPage3: 1,
            hover: false,
            gonggao: [],
            pageNo: "1",
            pageNos: "1",
            PageSize: 10,
            PageSizes: 10,
            totals: 0,
            gonggao_title: 0,
            list: true,
            detailsId: "",
            status: "",
        };
    },

    mounted() {
        this.inits(this.pageNos);
    },
    components: {
        Details,
    },
    methods: {

        initwomdow() {
            window.scrollTo(0, 0);
        },

        handleCurrentChanges(val) {
            this.pageNos = val;
            this.inits(this.pageNos);
        },
        // 跳页面
        tiaoyemain(main) {
            this.list = true;
            this.$router.push({
                name: main,
            });
            this.$route.params.id = "";
        },
        // 新闻详情
        toNewsAnd(id) {
            this.detailsId = id;
            this.status = "news";
            this.initwomdow();
            this.list = false;
        },
        // 服务公告
        toAnnounceAnd(id) {
            this.detailsId = id;
            this.status = "announce";
            this.initwomdow();
            this.list = false;

        },


        // init(pageNo) {
        //     if (this.$route.params.id == undefined || this.$route.params.id == "") {
        //         // 初始化新闻页面
        //         let s = {
        //             page: {
        //                 pageNo: this.pageNo,
        //                 pageSize: "10",
        //             },
        //             value: {
        //                 modular: '0',
        //                 languageState: "1"
        //             }
        //         };
        //         this.$axios
        //             .post("/news/getNews", s)
        //             .then((res) => {
        //                 this.totals = res.page.totalCount;
        //                 this.details = res.value.allList;
        //             })
        //             .catch((err) => {
        //                 this.$message.error(err.data.message);
        //             });
        //     } else {
        //         let id = this.$route.params.id;
        //         this.toNewsAnd(id);
        //     }
        // },
        inits(pageNos) {
            let id = this.$route.params.id;
            if (this.$route.params.id == undefined || this.$route.params.id == "") {
                // 初始化服务公告
                let gonggao = {
                    page: {
                        pageNo: pageNos,
                        pageSize: "10",
                    },
                    value: {
                        languageState: "1"
                    }
                };
                this.$axios
                    .post("/announcement/getAnnouncement", gonggao)
                    .then((res) => {
                        this.gonggao_title = res.page.totalCount;
                        this.gonggao = res.value.allList;
                    })
                    .catch((err) => {
                        this.$message.error(err.data.message);
                    });
            } else {
                this.toAnnounceAnd(id)
            }

        },
    },
};
</script>

<style scoped lang="scss">
.newsandinformation {
    background: #f7f8fa;
    padding-bottom: 55px;

    .news_image {
        margin-bottom: 23px;
    }

    .introduction {
        margin-top: 22px;
        overflow: hidden;
    }

    .container_full {
        width: 1200px;
    }

    .po_r {
        position: relative;
    }

    .m_a {
        margin: 0 auto;
    }

    .about_us {
        background: #ffffff;
        display: inline-block;
        width: 220px;
        height: 220px;
        box-shadow: 0px 0px 12px 0px rgba;

        p {
            padding: 20px 0 0 24px;
            font-size: 20px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 28px;
        }

        .e_abt {
            padding: 20px 0 20px 24px;
            font-size: 18px;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
            line-height: 0px;
        }
    }

    .active {
        padding-top: 10px;
        list-style-type: none;

        .span_css {
            margin-left: 42px;
        }

        p {
            padding: 18px 0 18px 24px;
            position: relative;
            /* background: linear-gradient(90deg,rgba(237,105,0,1) 0%,rgba(253,174,50,1) 100%);*/
            background: linear-gradient(90deg, #004b9c 0%, #004b9c 100%);
            filter: progid:DXImageTransform.Microsoft.gradient(GradientType=1, startColorstr=#004B9C, endColorstr=#004B9C);
            font-size: 16px;
            font-weight: 500;
            color: rgba(255, 255, 255, 1);
            line-height: 22px;
            margin-left: -40px;

            ::before {
                content: "";
                position: absolute;
                width: 0;
                height: 0;
                border-top: 7px solid transparent;
                /* border-left: 12px solid rgba(205,82,41,1);*/
                border-left: 12px solid #004b9c;
                right: -12px;
                top: -7px;
            }

            ::after {
                content: "";
                position: absolute;
                width: 12px;
                height: 58px;
                /*background: #FDAE32;*/
                background: #004b9c;
                right: -12px;
                top: 0;
            }
        }
    }

    .info {
        display: block;
        margin-top: -10px;

        .info1 {
            // background: #004b9c;
            height: 45px;
            margin-top: 10px;
        }

        .info_active {
            cursor: pointer;
            display: block;
            padding-top: 13px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            line-height: 20px;
            margin-left: 30px;
        }
    }

    .com_profile {
        // width: 960px;
        background: #ffffff;
        display: none;

        .profile_top {
            width: 906px;
            border-bottom: 1px solid rgba(238, 238, 238, 1);

            ul {
                float: right;
                display: inline-block;
                padding: 26px 0 26px 0;
            }

            li {
                display: inline-block;
                font-size: 14px;
                color: rgba(51, 51, 51, 1);
                line-height: 16px;
                position: relative;
                padding-right: 14px;

                ::after {
                    position: absolute;
                    content: "";
                    width: 4px;
                    height: 7px;
                    top: 4px;
                    right: 4px;
                }
            }

            .head_title {
                display: inline-block;

                p {
                    padding: 24px 0 20px 0;
                    display: inline-block;
                    font-size: 18px;
                    font-weight: 400;
                    color: rgba(51, 51, 51, 1);
                    line-height: 25px;
                    position: relative;
                }

                ::before {
                    position: absolute;
                    content: "";
                    left: -15px;
                    top: 27px;
                    width: 6px;
                    height: 18px;
                    background: #004b9c;
                }
            }
        }
    }

    .com_profile_active {
        display: block;
    }

    .fanhui {
        .fanh {
            height: 20px;
            font-size: 14px;
            font-weight: 400;
            color: #999999;
            line-height: 20px;
            margin-top: 30px !important;
            transition: transform 0.5s ease;

            &:hover {
                transform: scale(1.1);
                color: #004b9c;
                width: 50%;
                height: 2px;
                border-bottom: solid #004b9c 1px;


            }

        }

        .active {
            color: gray !important;
            border-bottom: 2px solid;
        }
    }

    .detail {
        background: rgba(255, 255, 255, 1);
        padding-bottom: 37px;
        padding-left: 48px;
        padding-right: 48px;

        ::v-deep .el-tabs__content {
            margin-top: -10px;
        }

        .profile_middle {
            width: 100%;

            .news_ul {
                .news_list {
                    // width: 100%;
                    height: 80px;
                    padding-left: 40px;
                    padding-right: 16px;
                    border-bottom: 1px solid #f2f2f2;
                    line-height: 80px;

                    .short_line {
                        float: right;
                        font-size: 14px;
                        font-weight: 400;
                        color: #7c7c7c;
                        line-height: 80px;
                        cursor: pointer;
                    }
                }

                .con_left {
                    float: left;
                    margin-top: -40px;
                }

                .con_left_css {
                    float: left;
                }

                .news_tag {
                    font-size: 18px;
                    font-weight: 400;
                    color: #333333;
                    line-height: 25px;
                    margin-top: 17px;
                    cursor: pointer;

                    .span_css2 {
                        margin-top: -10px;
                    }

                    .img_css {
                        width: 20px;
                        height: 45px;
                        position: relative;
                        top: 40px;
                        left: -30px;
                        z-index: 3000;
                    }

                    .img_css_two {
                        width: 20px;
                        height: 45px;
                        position: relative;
                        left: -30px;
                        z-index: 3000;
                    }

                    .span_css3 {
                        display: block;
                        margin-top: -50px;
                        width: 710px;
                        font-size: 14px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                }

                .news_content {
                    font-weight: 400;
                    color: #7c7c7c;
                    line-height: 20px;
                    padding-top: 8px;
                    cursor: pointer;

                    .news_content_span {
                        display: block;
                        width: 710px;
                        font-size: 14px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        -o-text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                }
            }
        }

        .page {
            margin-top: 20px;

            .block {
                text-align: center;

                ::v-deep .el-pager li.active {
                    // color: #f08300;
                }

                ::v-deep .el-pager li:hover {
                    // color: #f08300;
                }
            }
        }
    }
}
</style>